

import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    inquiryType: '',
    course: '',
    treatmentType: '',
    headSpaOption: '',
    preferredDate: '',
    preferredTime: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d3gici8oo35phc13lncg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formDataToSend as any).toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          inquiryType: '',
          course: '',
          treatmentType: '',
          headSpaOption: '',
          preferredDate: '',
          preferredTime: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-96 flex items-center justify-center bg-green-50"
      >
        <div className="container mx-auto px-4 text-center text-gray-900">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">お申し込み・お問い合わせ</h1>
          <p className="text-xl">お気軽にご相談ください</p>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              {/* Contact Information */}
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">お問い合わせ先</h2>
                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-4 mt-1">
                      <i className="ri-mail-line text-green-600"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">メールアドレス</h3>
                      <p className="text-gray-600">healthcoach.yoshiko@gmail.com</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-4 mt-1">
                      <i className="ri-line-fill text-green-600"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">LINE</h3>
                      <a 
                        href="https://lin.ee/efJX94s" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-green-600 hover:text-green-700 cursor-pointer underline"
                      >
                        LINEでのお問い合わせ
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-4 mt-1">
                      <i className="ri-time-line text-green-600"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">営業時間</h3>
                      <div className="text-gray-600 space-y-1">
                        <p>土曜: 8:00 - 23:00</p>
                        <p>日曜: 8:00 - 22:00</p>
                        <p className="text-sm mt-2">※平日・早朝・深夜でも個別相談可能です。お気軽にお問い合わせください。</p>
                        <p className="text-sm">※お問い合わせには、平日も含め２日以内に回答させていただきます。</p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-4 mt-1">
                      <i className="ri-map-pin-line text-green-600"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">アクセス</h3>
                      <div className="text-gray-600 space-y-1">
                        <p>東京都新宿区若松町</p>
                        <p>都営大江戸線「若松河田」駅　徒歩４分</p>
                        <p>東京メトロ東西線「早稲田」駅　徒歩12分</p>
                        <p className="text-sm mt-2">（住所の詳細はお申込み/ご予約いただいた方に別途ご案内させていただきます）</p>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Map */}
                <div className="mt-8">
                  <h3 className="font-semibold text-gray-900 mb-4">アクセス</h3>
                  <div className="bg-gray-100 rounded-lg h-64 flex items-center justify-center">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.827944!2d139.7280611!3d35.6938776!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188d2059b7fd4b%3A0x7b3d4d4d4d4d4d4d!2z6Iul5p2-55S677yM5p2x5Lqs6YO95paw5a6_5Yy66Iul5p2-55S6!5e0!3m2!1sja!2sjp!4v1640995200000"
                      width="100%"
                      height="100%"
                      style={{ border: 0, borderRadius: '0.5rem' }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                </div>
              </div>

              {/* Contact Form */}
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">お申し込み・お問い合わせフォーム</h2>
                
                {submitStatus === 'success' && (
                  <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
                    <div className="flex items-center">
                      <div className="w-5 h-5 flex items-center justify-center mr-3">
                        <i className="ri-check-circle-line text-green-600"></i>
                      </div>
                      <p className="text-green-800">お問い合わせありがとうございます。2営業日以内にご返信いたします。</p>
                    </div>
                  </div>
                )}
                
                {submitStatus === 'error' && (
                  <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
                    <div className="flex items-center">
                      <div className="w-5 h-5 flex items-center justify-center mr-3">
                        <i className="ri-error-warning-line text-red-600"></i>
                      </div>
                      <p className="text-red-800">送信に失敗しました。お手数ですが、もう一度お試しください。</p>
                    </div>
                  </div>
                )}

                <form onSubmit={handleSubmit} data-readdy-form id="contact-form" className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                        お名前 <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                        placeholder="山田 太郎"
                      />
                    </div>
                    
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                        メールアドレス <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                        placeholder="example@email.com"
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                      電話番号
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                      placeholder="03-1234-5678"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="inquiryType" className="block text-sm font-medium text-gray-700 mb-2">
                      お問い合わせ種類 <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="inquiryType"
                      name="inquiryType"
                      value={formData.inquiryType}
                      onChange={handleInputChange}
                      required
                      className="w-full px-3 py-2 pr-8 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                    >
                      <option value="">選択してください</option>
                      <option value="講座申し込み">講座申し込み</option>
                      <option value="トリートメント予約">トリートメント予約</option>
                      <option value="その他問い合わせ">その他問い合わせ</option>
                    </select>
                  </div>
                  
                  {formData.inquiryType === '講座申し込み' && (
                    <div>
                      <label htmlFor="course" className="block text-sm font-semibold text-gray-700 mb-2">
                        希望講座
                      </label>
                      <select
                        id="course"
                        name="course"
                        value={formData.course}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 pr-8 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                      >
                        <option value="">選択してください</option>
                        <option value="ハウスケア">ハウスケア</option>
                        <option value="スキンケア">スキンケア</option>
                        <option value="セルフケア">セルフケア</option>
                        <option value="yuica認定日本産精油アドバイザー資格講座">yuica認定日本産精油アドバイザー資格講座</option>
                      </select>
                    </div>
                  )}
                  
                  {formData.inquiryType === 'トリートメント予約' && (
                    <>
                      <div>
                        <label htmlFor="treatmentType" className="block text-sm font-medium text-gray-700 mb-2">
                          希望コース
                        </label>
                        <select
                          id="treatmentType"
                          name="treatmentType"
                          value={formData.treatmentType}
                          onChange={handleInputChange}
                          className="w-full px-3 py-2 pr-8 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                        >
                          <option value="">選択してください</option>
                          <option value="70分スタンダードコース">70分スタンダードコース（所要時間：90分（初回は120分程度））</option>
                          <option value="40分クイックコース">40分クイックコース（所要時間：60分（初回は90分程度））</option>
                        </select>
                      </div>
                      
                      {formData.treatmentType && (
                        <div>
                          <label htmlFor="headSpaOption" className="block text-sm font-medium text-gray-700 mb-2">
                            ドライヘッドスパ（オプション）
                          </label>
                          <select
                            id="headSpaOption"
                            name="headSpaOption"
                            value={formData.headSpaOption}
                            onChange={handleInputChange}
                            className="w-full px-3 py-2 pr-8 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                          >
                            <option value="">追加しない</option>
                            <option value="10分コース">10分コース（1,100円）</option>
                            <option value="20分コース">20分コース（2,200円）</option>
                            <option value="30分コース">30分コース（3,300円）</option>
                          </select>
                        </div>
                      )}
                    </>
                  )}
                  
                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                      メッセージ・ご質問
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      rows={5}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm resize-vertical"
                      placeholder="※受講の時間帯・曜日等でご希望がありましたらご記載ください.&#10;※講座申し込みの方で、ご希望のクラフトがある方はご記載ください。料金案内をさせていただきます。"
                    />
                  </div>
                  
                  <Button
                    type="submit"
                    size="lg"
                    className="w-full"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? '送信中...' : '送信する'}
                  </Button>
                </form>
              </div>
            </div>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
}

